import {FlowTypeEnum, getUfPath} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';

export function useLocalitiesSelection(flowType: FlowTypeEnum) {
	const navigate = useNavigate();

	const bookingUfPath = getUfPath(flowType);

	const handleClose = () => {
		navigate(bookingUfPath);
	};

	const handleBack = () => {
		navigate(bookingUfPath);
	};

	return {
		handleClose,
		handleBack,
		bookingUfPath,
	};
}
